const ActionTypes = {
  // General
  SHOW_ALERT: "SHOW_ALERT",
  HIDE_ALERT: "HIDE_ALERT",
  SHOW_RINGING: "SHOW_RINGING",
  HIDE_RINGING: "HIDE_RINGING",
  DECLINE_RINGING: "DECLINE_RINGING",
  SHOW_LOADING: "SHOW_LOADING",
  HIDE_LOADING: "HIDE_LOADING",
  GENERAL_TYPES: "GENERAL_TYPES",
  UPDATE_TYPES: "UPDATE_TYPES",
  SESSION_EXPIRED: "SESSION_EXPIRED",

  // Theme
  UPDATE_THEME: "UPDATE_THEME",

  // User
  GET_USER: "GET_USER",
  ChangeThemeColor: "ChangeThemeColor",
  ChangeThemeFont: "ChangeThemeFont",
  UpdateUserProfile: "UpdateUserProfile",
  NotificationSwitch: "NotificationSwitch",
  IsLogin: "IsLogin",
  IsLogout: "IsLogout",

  //Events
  UPCOMING_EVENTS: "UPCOMING_EVENTS",
  EVENTS_HISTORY: "EVENTS_HISTORY",
  EVENTS: "EVENTS",
  EVENT_DETAIL: "EVENT_DETAIL",
  CLEAR_DETAIL: "CLEAR_DETAIL",
  UPDATE_EVENT: "UPDATE_EVENT",
  EDIT_EVENT: "EDIT_EVENT",
  DELETE_EVENT: "DELETE_EVENT",
  EVENT_BUDGET: "EVENT_BUDGET",
  EVENT_BUDGET_CAT: "EVENT_BUDGET_CAT",
  GET_WEDING_WALL: "GET_WEDING_WALL",
  GET_WEDING_WEB: "GET_WEDING_WEB",
  GET_LIVE_CHANNEL_DATA: "GET_LIVE_CHANNEL_DATA",

  //Payment
  GET_SUBSCRIPTIONS: "GET_SUBSCRIPTIONS",
  GET_PAYMENT_CARDS: "GET_PAYMENT_CARDS",
  UPDATE_PAYMENT_CARDS: "UPDATE_PAYMENT_CARDS",
  UPDATE_ACTIVE_CARDS: "UPDATE_ACTIVE_CARDS",

  //Inspirational Gallery
  GET_GALLERY: "GET_GALLERY",
  UPDATE_GALLERY: "UPDATE_GALLERY",
  GET_SPECIFIC_CATEGORY: "GET_SPECIFIC_CATEGORY",
  CLEAR_SPECIFIC_CATEGORY: "CLEAR_SPECIFIC_CATEGORY",
  DELETE_GALLERY: "DELETE_GALLERY",

  //Photos
  GET_ALL_PHOTOS: "GET_ALL_PHOTOS",
  CLEAR_ALL_PHOTOS: "CLEAR_ALL_PHOTOS",
  GET_ALBUM: "GET_ALBUM",
  CLEAR_ALBUM: "CLEAR_ALBUM",
  GET_MY_PHOTOS: "GET_MY_PHOTOS",
  CLEAR_MY_PHOTOS: "CLEAR_MY_PHOTOS",
  UPDATE_MY_PHOTOS: "UPDATE_MY_PHOTOS",
  GET_EVENT_GALLERY_CATEGORIES: "GET_EVENT_GALLERY_CATEGORIES",

  //Checklist
  WEEKLY_CHECKLIST: "WEEKLY_CHECKLIST",
  MONTHLY_CHECKLIST: "MONTHLY_CHECKLIST",
  ALL_CHECKLIST: "ALL_CHECKLIST",
  CLEAR_CHECKLIST: "CLEAR_CHECKLIST",
  CALENDAR_CHECKLIST: "CALENDAR_CHECKLIST",

  // Templates
  TEMPLATES: "TEMPLATES",
  MY_TEMPLATES: "MY_TEMPLATES",
  UPDATE_TEMPLATE: "UPDATE_TEMPLATE",
  DELETE_TEMPLATE: "DELETE_TEMPLATE",

  //Dashboard
  CLIENT_DASHBOARD: "CLIENT_DASHBOARD",
  VENDOR_DASHBOARD: "VENDOR_DASHBOARD",
  GUEST_DASHBOARD: "GUEST_DASHBOARD",

  // Guest
  GET_GUEST_GROUP: "GET_GUEST_GROUP",
  DELETE_GUEST_GROUP: "DELETE_GUEST_GROUP",
  GUEST_LIST: "GUEST_LIST",
  GUEST_UPCOMING_EVENTS: "GUEST_UPCOMING_EVENTS",
  GUEST_EVENTS_WEDWALL: "GUEST_EVENTS_WEDWALL",
  GUEST_EVENTS_DETAIL: "GUEST_EVENTS_DETAIL",
  GET_GUEST_RSVP_DETAILS: "GET_GUEST_RSVP_DETAILS",

  // Menu
  GET_MENU: "GET_MENU",

  //Advertisement
  CREATE_ADVERTISEMENT: "CREATE_ADVERTISEMENT",
  GET_MY_ADVERTISEMENTS: "GET_MY_ADVERTISEMENTS",
  CLEAR_ADVERTISEMENTS: "CLEAR_ADVERTISEMENTS",
  DELETE_ADVERTISEMENT: "DELETE_ADVERTISEMENT",

  // Vendors
  ADD_NEW_VENDOR: "ADD_NEW_VENDOR",
  GET_YOUR_VENDORS: "GET_YOUR_VENDORS",
  GET_FIND_VENDORS: "GET_FIND_VENDORS",
  REMOVE_VENDOR_FROM_EVENT: "REMOVE_VENDOR_FROM_EVENT",
  CLEAR_YOUR_VENDORS: "CLEAR_YOUR_VENDORS",
  CLEAR_FIND_VENDORS: "CLEAR_FIND_VENDORS",
  CLEAR_FIND_VENDORS_BY_CATEGORY: "CLEAR_FIND_VENDORS_BY_CATEGORY",
  GET_FIND_VENDORS_BY_CATEGORY: "GET_FIND_VENDORS_BY_CATEGORY",
  GET_SUB_CONTACTS: "GET_SUB_CONTACTS",
  CLEAR_SUB_CONTACTS: "CLEAR_SUB_CONTACTS",
  GET_VENDOR_PHOTOS: "GET_VENDOR_PHOTOS",
  UPDATE_SUB_CONTACTS: "UPDATE_SUB_CONTACTS",
  GET_VENDOR_DETAILS: "GET_VENDOR_DETAILS",

  // Menu
  GET_MENU: "GET_MENU",

  // Event Table & Seating
  GET_SEATING: "GET_SEATING",
  GET_ATTENDEE: "GET_ATTENDEE",
  GET_PENDING: "GET_PENDING",
  ATTENDEE_DETAIL: "ATTENDEE_DETAIL",

  // Request RSVP
  SET_RSVP: "SET_RSVP",
  GET_TIDBITS: "GET_TIDBITS",
  GET_QNA: "GET_QNA",
  CLEAR_RSVP: "CLEAR_RSVP",

  //Pages
  GET_PAGES_INFORMATION: "GET_PAGES_INFORMATION",

  //Vendor Plannig Templates
  GET_VENDOR_EVENTS: "GET_VENDOR_EVENTS",
  GET_PLANNING_TEMPLATES: "GET_PLANNING_TEMPLATES",
  GET_WEDDING_PLANNING_TEMPLATES: "GET_WEDDING_PLANNING_TEMPLATES",
  CREATE_PLANNING_TEMPLATES: "CREATE_PLANNING_TEMPLATES",
  GET_SECTION: "GET_SECTION",
  GET_SUB_SECTION: "GET_SUB_SECTION",
  CREATE_SECTION: "CREATE_SECTION",
  CREATE_SUB_SECTION: "CREATE_SUB_SECTION",
  UPDATE_SECTION: "UPDATE_SECTION",
  DELETE_SECTION: "DELETE_SECTION",
  GET_QUESTION: "GET_QUESTION",
  CREATE_QUESTION: "CREATE_QUESTION",
  UPDATE_QUESTION: "UPDATE_QUESTION",
  DELETE_QUESTION: "DELETE_QUESTION",
  GET_PUBLIC_TEMPLATES: "GET_PUBLIC_TEMPLATES",
  CLEAR_QUESTION: "CLEAR_QUESTION",
  // Chat & ChatRoom
  GET_CHAT_ROOM: "GET_CHAT_ROOM",
  GET_CHAT_LIST: "GET_CHAT_LIST",
  GET_CHAT_MESSAGES: "GET_CHAT_MESSAGES",
  UPDATE_CHAT_MESSAGES: "UPDATE_CHAT_MESSAGES",
  RESET_CHAT: "RESET_CHAT",
  GET_MESSAGES: "GET_MESSAGES",
  GET_VENDOR_MESSAGES: "GET_VENDOR_MESSAGES",
  GET_VENDOR_LIST: "GET_VENDOR_LIST",
  GET_GUEST_LIST: "GET_GUEST_LIST",
  DELETE_VENDOR: "DELETE_VENDOR",
  REMOVE_SUB_VENDOR: "REMOVE_SUB_VENDOR",

  //Event Reminder
  GET_EVENT_REMINDER: "GET_EVENT_REMINDER",

  //Event Timeline
  GET_EVENT_TIMELINE: "GET_EVENT_TIMELINE",

  //Analytics
  GET_ANALYTICS: "GET_ANALYTICS",

  //View Result
  GET_VIEW_RESULT: "GET_VIEW_RESULT",

  //Reviews
  GET_REVIEWS: "GET_REVIEWS",

  //Notifications
  GET_NOTIFICATIONS: "GET_NOTIFICATIONS",
  GET_UNREAD_NOTIFICATIONS: "GET_UNREAD_NOTIFICATIONS",

  //Client Planning Form
  GET_CLIENT_PLANNING_FORM: "GET_CLIENT_PLANNING_FORM",
  GET_CLIENT_SECTION: "GET_CLIENT_SECTION",
  GET_CLIENT_SUB_SECTION: "GET_CLIENT_SUB_SECTION",
  GET_CLIENT_QUESTION: "GET_CLIENT_QUESTION",

  //Guest Rsvp
  UPDATE_GUEST_RSVP_EVENT: "UPDATE_GUEST_RSVP_EVENT",

  //Playlist
  GET_PLAYLIST: "GET_PLAYLIST",
  GET_PUBLIC_PLAYLIST: "GET_PUBLIC_PLAYLIST",

  //Songs
  GET_PLAYLIST_SONGS: "GET_PLAYLIST_SONGS",
};

export default ActionTypes;
